import { Component, type ReactNode } from 'react';
import AppErrorScreen from './AppErrorScreen';

interface AppErrorBoundaryProps {
    resetKey: string;
    children: ReactNode;
}

interface AppErrorBoundaryState {
    error: unknown;
}

/** Ловить падіння під час малювання і лишає меню з шапкою на місці. */
class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    state: AppErrorBoundaryState = { error: null };

    static getDerivedStateFromError(error: unknown): AppErrorBoundaryState {
        return { error };
    }

    componentDidCatch(error: unknown) {
        console.error(error);
    }

    componentDidUpdate(prevProps: AppErrorBoundaryProps) {
        if (this.state.error != null && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ error: null });
        }
    }

    render() {
        if (this.state.error != null) return <AppErrorScreen error={this.state.error} />;
        return this.props.children;
    }
}

export default AppErrorBoundary;
